import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withFetch, // Add withFetch
} from '@angular/common/http';
import { routes } from './app.routes';
import {
  provideRouter,
  ROUTER_CONFIGURATION,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration, withEventReplay, withIncrementalHydration } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideToastr } from 'ngx-toastr';
import { AuthGuard } from './services/auth-guard.service';
import { ApiInterceptor } from './services/api.interceptor';
import { HttpErrorInterceptor } from './services/httperror.interceptor';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { environment } from '../environments/environment';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

export const appConfig: ApplicationConfig = {
  providers: [
    AuthGuard,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // provideRouter(
    //   routes,
    //   withInMemoryScrolling({
    //     scrollPositionRestoration: 'enabled',
    //     anchorScrolling: 'enabled',
    //   }),
    //   withComponentInputBinding()
    // ),
    provideHttpClient(withInterceptorsFromDi(), withFetch()), // Enable fetch API
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    // {
    //   provide: ROUTER_CONFIGURATION,
    //   useValue: { onSameUrlNavigation: 'reload' }
    // },
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    // provideClientHydration(withIncrementalHydration()),
    provideAnimationsAsync(),
    provideToastr(),
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule
    ),
    provideLottieOptions({
      player: () => player,
    }),
  ],
};